// DarkModeContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const DarkModeContext = createContext();

export const useDarkMode = () => useContext(DarkModeContext);

export const DarkModeProvider = ({ children }) => {
  const [darkMode, setDarkMode] = useState(false);
  const [selectedColor, setSelectedColor] = useState('rgb(229, 186, 115)');

  useEffect(() => {
    const savedDarkMode = localStorage.getItem('theme');
    if (savedDarkMode === 'darkTheme') {
      document.body.classList.add('dark-mode');
      setDarkMode(true);
    } else {
      document.body.classList.remove('dark-mode');
      setDarkMode(false);
    }

    localStorage.getItem('selectedColor');

  }, []);



  const toggleDarkMode = (newMode) => {
    const mode = typeof newMode === 'boolean' ? newMode : !darkMode;
    setDarkMode(mode);
    localStorage.setItem('theme', mode ? 'darkTheme' : 'lightTheme');
    if (mode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }

  };

  const setColor = (color) => {
    setSelectedColor(color);
    localStorage.setItem('selectedColor', color);
  };



  return (
    <DarkModeContext.Provider value={{ darkMode, toggleDarkMode, selectedColor, setColor }}>
      {children}
    </DarkModeContext.Provider>);

};